
        import * as module0 from './controllers/clipboard_controller.js';import * as module1 from './controllers/disqus_controller.js';import * as module2 from './controllers/theme_picker_controller.js'
        const modules = {
            "./controllers/clipboard_controller.js": module0,
            "./controllers/disqus_controller.js": module1,
            "./controllers/theme_picker_controller.js": module2,
        };
        export default modules;
      